<template>
  <div>
    <v-container class="mt-0">
      <v-row justify="center" align="center" align-content="center" no-gutters class="mt-12">
        <v-col class="pa-3 ma-3" offset-md="2" md="7">
          <v-card>
            <v-card-title><h1 class="title text-uppercase">S'inscrire</h1>
            </v-card-title>
            <v-card-text><p>Venez vivre une expérience nouvelle et prometteuse.
              Apportez votre imagination, vos compétences, votre sensibilité, pour contribuer à changer la vie des
              patients et des personnes en situation de handicap. Ouvrez-leur l’univers infini du jeu, changez les
              règles pour qu'eux aussi sourient et vivent des moments intenses. Que vous soyez professionnel de santé,
              développeur, fan de jeux, patient, musicien, aidant, graphiste, dessinateur, bidouilleurs en tous
              genres...</p>
              <p>N’hésitez pas à rejoindre l’événement : c’est de la diversité des talents que naîtront les meilleurs
                projets. Vous avez l’esprit ouvert et la volonté de collaborer au bénéfice du bien commun, vous serez
                accueillis à bras ouverts !</p>
            </v-card-text>
            <v-card-actions>
              <contact-us texte="Coach ou bénévole" color="orange"></contact-us>
              <v-btn @click="$vuetify.goTo('#form')" text color="orange">Participants</v-btn>
              <contact-us texte="Un projet ?" color="orange"></contact-us>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" offset-md="0" md="3" align-self="center">
          <v-img
              alt="Ludi Health"
              class="shrink"
              contain
              src="@/assets/logo_banner.png"
              transition="scale-transition"
              max-width="438px"
          />
        </v-col>
      </v-row>
    </v-container>
    <v-img src="../../public/img/health.webp" gradient="to top right, rgba(233,153,34,.9), rgba(233,153,34,.9)"
           height="calc( 35vh - 48px )" class="white--text mt-10 mb-10" width="100%">
      <v-row
          class="fill-height ma-0 text-center"
          :class="$vuetify.breakpoint.smAndUp?'display-3':'display-1'"
          align="center"
          justify="center"
      >
        Formulaire
      </v-row>
    </v-img>
    <v-container>
      <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSegp8RlP7Iey-hFOLAyizI1qUWkTU5agZiN_LafQiO-0lTRuA/viewform?embedded=true"
          width="100%" height="800" frameborder="0" marginheight="0" marginwidth="0" class="ma-auto"
          id="form">
        Chargement…
      </iframe>
    </v-container>
  </div>
</template>

<script>
import ContactUs from "../components/ContactUs";

export default {
  name: "Subscribe",
  components: {ContactUs}
}
</script>

<style scoped>

</style>